<template>
    <div class="user_msg">
        <ul class="apps">
            <li v-for="(item,i) in apps" :class="{'active':app_id == item.id,'notice':item.id == 3975}" :key="i" @click="chooseApp(item.id,i)">
                <van-image :src="item.icon" v-if="item.id != 3975"/>
                <van-image :src="require('../../assets/version_1.3.7/notice.png')"  v-else />
                <p class="count" v-if="item.notice_count > 0">{{ item.notice_count > 99 ? '99+' :  item.notice_count}}
                </p>
            </li>
        </ul>
        <div class="msg_area">
            <van-pull-refresh v-model="pullloading" @refresh="onRefresh" v-if="app_id">
                <div class="msg_list">
                    <msg-scroll url="goods-notice/index" :params="{app_id}" method="get" @on-fetch="fetch" ref="msg">
                        <template slot-scope="scope">
                            <div class="notice_item" v-for="(item,i) in scope.data" :key="i"
                                @click="readNotice(i,item.id,item.is_read,item.goods_type,item.otype,item.goods_id,item.order_num)">
                                <p class="tit_time">
                                    <span class="tit">{{ status_maps[item.otype] }}</span>
                                    <span class="time">{{ item.ctime | judgeDate}}</span>
                                </p>
                                <p class="content">
                                    <span>{{ item.content }}</span>
                                    <a href="javascript:;" v-if="item.is_read == 0&&item.otype != 7 && item.otype != 8">前往查看</a>
                                    <a href="javascript:;" v-if="item.otype == 7" @click.stop="gotoModifyAccount(i,item.id,item.is_read,item.goods_type,item.otype,item.goods_id,item.order_num)">点击前往修改&gt;</a>
                                    <i v-if="item.is_read == 0"></i>
                                </p>
                            </div>
                        </template>
                    </msg-scroll>
                </div>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                pullloading: false,
                apps: [],
                app_id: null,
                app_index: 0,
                status_maps: [],
                // "status_maps": {
                // "1": "商品审核通过啦！",
                // "2": "商品审核未通过",
                // "3": "商品已下架",
                // "4": "商品正在交易",
                // "5": "交易完成",
                // "6": "商品已发货"
                // },
            }
        },
        filters: {
            judgeDate(time) {
                var artTime = time.replace(/-/g, '/')
                var str = ''
                if (new Date(artTime).getDate() == new Date().getDate()) {
                    str = time.slice(10, 16)
                } else if (new Date(artTime).getDate() == new Date().getDate() - 1) {
                    str = '昨日'
                } else {
                    str = artTime.slice(0, 10)
                }
                return str
            },
        },
        computed: {

        },
        created() {},
        mounted() {
            this.getApps()
        },
        methods: {
            fetch(data) {
                this.status_maps = data.status_maps
            },
            getApps() {
                this.$Ajax('goods-notice/apps', {}, 'get').then(rs => {
                    if (rs.code == 200) {
                        this.apps = rs.data
                        if (!this.app_id) {
                            this.app_id = this.apps[0].id
                        }
                    }
                })
            },
            chooseApp(id, index) {
                this.app_id = id
                this.app_index = index
                this.$refs.msg.refresh()
            },
            readNotice(i, id, is_read, goods_type, otype, goods_id, order_num) {
                this.$refs.msg.data[i].is_read = 1
                if (this.apps[this.app_index].notice_count > 0) {
                    this.apps[this.app_index].notice_count--
                }
                if (is_read == 0) {
                    this.$Ajax('goods-notice/read', {
                        id
                    }, 'get')
                }
                // "status_maps": {
                // "1": "商品审核通过啦！",
                // "2": "商品审核未通过",
                // "3": "商品已下架",
                // "4": "商品正在交易",
                // "5": "交易完成",
                // "6": "商品已发货"
                // },
                //有订单号的
                if (order_num != '') {
                    if (goods_type == 1) {
                        if (otype == 6) {
                            this.$router.push({
                                name: "goods.detail",
                                query: {
                                    order_num,
                                    type: 'buy',
                                },
                            });
                        }
                    } else {
                        if(otype == 7 || otype == 8) {
                            //this.gotoModifyAccount(order_num)
                            return
                        } else {
                            this.$router.push({
                                name: 'user.order',
                                query: {
                                    order_num,
                                    // type: 'buy',
                                }
                            })
                        }
                    }
                } else {
                    // 没订单号的
                    if (goods_type == 1) {
                        this.$store.commit('setGameInfo', {
                          name:this.apps[this.app_index].app_name,
                          icon:this.apps[this.app_index].icon,
                          id:this.apps[this.app_index].id
                        })
                        this.$router.push({
                            name: "onsell",
                            query: {
                                id: goods_id
                            },
                        });
                    } else {
                        if(otype == 7 || otype == 8) {
                            return
                        }else {
                            this.$router.push({
                                name: 'order.detail',
                                query: {
                                    id: goods_id
                                }
                            })
                        }
                    }
                }
            },
            onRefresh() {
                var that = this;
                setTimeout(() => {
                    that.$refs.msg.refresh()
                    that.pullloading = false;
                }, 1000);
            },
            gotoModifyAccount(i, id, is_read, goods_type, otype, goods_id, order_num) {
                this.$refs.msg.data[i].is_read = 1
                if (this.apps[this.app_index].notice_count > 0) {
                    this.apps[this.app_index].notice_count--
                }
                if (is_read == 0) {
                    this.$Ajax('goods-notice/read', {
                        id
                    }, 'get')
                }
                this.$router.push({
                    name: "bind.account",
                    query: {
                        action: 'modify',
                        id: order_num
                    },
                });
            },
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
    .user_msg {
        height: calc(var(--vh, 1vh)*100 - 5rem);
        display: flex;

        .apps {
            width: 5.2rem;
            height: 100%;
            background-color: #E9E9E9;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-top-right-radius: .8rem;
            padding: 1.6rem 0;
            overflow-y: auto;

            li {
                width: 3.2rem;
                height: 3.2rem;
                margin-bottom: 1.8rem;
                position: relative;
                transition: all ease .3s;
                cursor: pointer;

                &:nth-last-child(1) {
                    margin-bottom: 0;
                }

                &.active {
                    transform: scale(1.3);
                    transform-origin: 0 0;
                    background-color: #fff;
                    border-top-left-radius: .8rem;
                    border-bottom-left-radius: .8rem;
                    padding: .1rem;
                }
                &.notice {
                    background-color: var(--theme);
                    border-radius: .8rem;
                    .van-image {
                        transform: scale(0.7);
                    }
                    &.active {
                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;
                    }
                }
                
                .van-image {
                    width: 100%;
                    height: 100%;
                    border-radius: .8rem;
                    overflow: hidden;
                }

                p {
                    position: absolute;
                    right: 0;
                    top: 0;
                    font-size: 1.4rem;
                    color: #fff;
                    background-color: #FF5E5E;
                    border-radius: 10rem;
                    padding: 0 .6rem;
                    transform: scale(0.5);
                    transform-origin: 100% 0;
                }
            }
        }

        .msg_area {
            flex: 1;
            overflow-y: auto;

            .msg_list {
                min-height: calc(var(--vh, 1vh)*100 - 5rem);
            }
        }
    }

    .notice_item {
        padding: 1.3rem 1rem;
        border-bottom: 1px solid #e9e9e9;
        cursor: pointer;

        &:nth-last-of-type(2) {
            border: none;
        }

        .tit_time {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: .5rem;

            .tit {
                font-size: 1.5rem;
                color: #000;
                font-weight: 700;
            }

            .time {
                font-size: 1.4rem;
                color: #929292;
            }
        }

        .content {
            font-size: 1.2rem;
            color: #666;
            word-break: break-all;
            line-height: 1.5;
            padding-right: 1rem;
            position: relative;

            a {
                color: #FF5E5E;
            }

            i {
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                width: .6rem;
                height: .6rem;
                background-color: #FF0000;
                border-radius: 50%;
            }
        }
    }

    .app0 {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: var(--theme50) !important;
        color: #fff;
    }
    .znx {
        font-size: 1.4rem;
        white-space: nowrap;
        transform: scale(0.6);
    }
    .notice_box {
  background-color: #fff;
  border-radius: 0.6rem;
  padding: 1rem 0.5rem;
  margin-bottom: 1rem;
  width: 100%;
  cursor: pointer;
  .nb_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.5rem 1rem 1.5rem;
    border-bottom: 1px solid #eee;

    .left {
      font-size: 1.5rem;
    }

    .right {
      .el-button {
        width: 7rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f2f2f2;
        font-size: 1.2rem;
        border-radius: 10rem;
      }
    }
  }

  .nb_content {
    padding: 0.9rem 1.5rem;
    font-size: 1.4rem;

    .icon {
      width: 3.6rem;
    }

    .goods_name {
      color: #e6681c;
      margin-right: 0.3rem;
    }

    .red {
      color: var(--red);
    }

    .success {
      color: var(--success);
    }
  }

  .nb_footer {
    padding: 0.5rem 1.5rem 0;
    display: flex;
    align-items: center;
    color: #bbb;

    .time {
      width: 1.85rem;
      height: 1.95rem;
      margin-right: 0.6rem;
    }
  }
}
</style>